import { render } from "./SetNetlifyURL.vue?vue&type=template&id=57ffbeca"
import script from "./SetNetlifyURL.vue?vue&type=script&lang=js"
export * from "./SetNetlifyURL.vue?vue&type=script&lang=js"
script.render = render

export default script